import { apiBaseUrl } from "./api";

type ProfilePhotoSource = {
  profilePhotoUrl?: string | null;
  profile_photo_url?: string | null;
  user?: {
    profilePhotoUrl?: string | null;
    profile_photo_url?: string | null;
  } | null;
} | null | undefined;

export function readProfilePhotoUrl(source: ProfilePhotoSource) {
  return (
    source?.profilePhotoUrl ??
    source?.profile_photo_url ??
    source?.user?.profilePhotoUrl ??
    source?.user?.profile_photo_url ??
    null
  );
}

export function resolveProfilePhotoSrc(value?: string | null) {
  if (!value) return null;
  if (/^(https?:|data:|blob:)/i.test(value)) return value;

  const path = value.startsWith("/") ? value : `/${value}`;
  return `${apiBaseUrl}${path}`;
}
